import { Center, Menu, Portal, Text } from '@chakra-ui/react';
import { useRepairFocus } from '@halo/ui-react';
import {
  // MessageLuckyBoxIcon,
  LuckyBoxIcon,
  TransferIcon,
  MessageMoreIcon,
  Tooltip,
} from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';
import { useId } from 'react';

export type MessageMoreButtonProps = {
  isGroup: boolean;
  onChange?: (value: string) => void;
};

export type MessageLuckyOption = {
  key: LuckyOptionKey;
  label: string;
  value: LuckyOptionKey;
  icon: React.ReactNode;
};

// eslint-disable-next-line react-refresh/only-export-components
export enum LuckyOptionKey {
  Transfer = 'Transfer',
  LuckyBox = 'LuckyBox',
}
export const MessageMoreButton = function MessageMoreButton({
  isGroup,
  onChange,
}: MessageMoreButtonProps) {
  const { t } = useTranslation();
  const { handleOpenChange } = useRepairFocus();
  const triggerId = useId();

  const options = useMemo(
    () =>
      [
        {
          key: LuckyOptionKey.Transfer,
          label: t('chat.transferText'),
          value: LuckyOptionKey.Transfer,
          icon: <TransferIcon />,
        },
        {
          key: LuckyOptionKey.LuckyBox,
          label: t('chat.luckyBoxText'),
          value: LuckyOptionKey.LuckyBox,
          icon: <LuckyBoxIcon />,
          hidden: !isGroup,
        },
      ].filter((option) => !option.hidden),
    [isGroup, t]
  );

  return (
    <Menu.Root
      ids={{ trigger: triggerId }}
      positioning={{ placement: 'top' }}
      onSelect={({ value }) => {
        onChange?.(value as LuckyOptionKey);
      }}
      onOpenChange={handleOpenChange}
    >
      <Tooltip
        ids={{ trigger: triggerId }}
        content={t('chat.tooltipMessageMore')}
        chakraPortal={false}
        openDelay={0}
        closeDelay={0}
        showArrow={true}
      >
        <Menu.Trigger asChild>
          <Center
            h="1.857em"
            w="1.857em"
            cursor="pointer"
            borderRadius="sm"
            _hover={{ bg: 'bg.muted', color: 'brand.100' }}
            transition="all 0.2s"
          >
            <Center className="shake">
              {/* <MessageLuckyBoxIcon /> */}
              <MessageMoreIcon />
            </Center>
          </Center>
        </Menu.Trigger>
      </Tooltip>
      <Portal>
        <Menu.Positioner>
          <Menu.Content
            borderRadius="lg"
            minW="186px"
            backdropFilter="blur(6px)"
            bg="whiteAlpha.70"
          >
            <Menu.Arrow />
            {options.map((option) => {
              return (
                <Menu.Item
                  key={option.key}
                  value={option.value}
                  gap="2"
                  px="2"
                  py="3"
                  borderRadius="sm"
                  cursor="pointer"
                  _hover={{ bg: 'bg.muted' }}
                >
                  <Center h="1.857em" w="1.857em" padding="0.2em">
                    {option.icon}
                  </Center>
                  <Text>{option.label}</Text>
                </Menu.Item>
              );
            })}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
